<template>
    <div class="page-container">
        <div class="max-width">
            <header class="page-header"
                    v-if="$slots.header">
                <slot name="header"></slot>
            </header>

            <div class="page-body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PageContainer'
};
</script>

<style lang="less">
.page-container {
    width: 100%;
    flex: 1;

    .max-width {
        display: block;
        max-width: @body-width;
        margin: 0 auto;
        padding: 20px 2px;
    }

    .page-header {
        margin-bottom: 20px;
        .el-breadcrumb__item {
            font-size: @font-bigger;
        }
    }

    .page-body {
        background: @white;
        box-shadow: 1px 1px 5px 2px @black-opacity-1;
        overflow: auto;
    }
}
</style>
